import React from "react";

const Drawer = ({ isOpen }) => {
  return isOpen ? <div>The Drawer</div> : null;
};
export default Drawer;
